export default "__VITE_ASSET__BrnrI7nA__"